import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VMain,[_c('router-view')],1),_c('GlobalSnackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }